import {
  PublicClientApplication, EventType
} from '@azure/msal-browser';
import { ACCESS_TOKEN, ACCOUNT, EXPIRES_ON,REFRESH_TOKEN, TIME_OF_AUTO_LOGOUT } from '../common/constants/local-storage-keys';
import { getLocalStorageItem, removeLocalStorageItem, setLocalStorageItem } from '../common/utils/local-storage';
import { setExpirationTimeout } from './msal-expiration';
import Cookies from 'universal-cookie';

let USE_SILENT_MODE = false;

function abandonSilentMode() {
  USE_SILENT_MODE = false;
}

function resetSilentMode() {
  USE_SILENT_MODE = (window?.env?.SSO_SILENT_LOGIN_ACTIVE || '').toLowerCase() === 'true';
}

resetSilentMode();

export function msalUseSilentMode() {
  return USE_SILENT_MODE;
}
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID,
    authority: process.env.REACT_APP_AUTHORITY_URL,
    redirectUri: process.env.REACT_APP_REDIRECT_URI,
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: true, // Enable for Safari/Mac compatibility
  },
  system: {
    allowNativeBroker: false, // Disable native broker for web apps
    windowHashTimeout: 60000, // Increase timeout for slower connections
    iframeHashTimeout: 6000,
    loadFrameTimeout: 0,
    navigateFrameWait: 0
  }
};

export const loginRequest = {
  scopes: [process.env.REACT_APP_SCOPES],
  prompt: "select_account", // Helps with account selection issues on Mac/Safari
};

export const logoutRequest = (instance) => {
  const userInfo = JSON.parse(localStorage.getItem('userInformation'));
  const homeAccountId = userInfo.account.homeAccountId;
  return {     
    account: instance.getAccountByHomeId(homeAccountId),     
    mainWindowRedirectUri: "https://localhost:3000",     
    postLogoutRedirectUri: "https://localhost:3000",   
  }
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
  graphMeEndpoint: "Enter_the_Graph_Endpoint_Here/v1.0/me",
};

export const msalClient = new PublicClientApplication(msalConfig);

msalClient.addEventCallback((message) => {
  const { eventType, payload } = message;
  const cookies = new Cookies();
  
  const successEvents = [
    EventType.ACQUIRE_TOKEN_SUCCESS,
    EventType.LOGIN_SUCCESS,
    EventType.SSO_SILENT_SUCCESS,
  ];
  if (successEvents.includes(eventType)) {
    const data = payload;
    if (data && data.account) {
      resetSilentMode();
      const expiresOnFromResponse = String(data.expiresOn);
      sessionStorage.setItem('userInformation', data);
      setLocalStorageItem(ACCESS_TOKEN, data.accessToken);
      setLocalStorageItem(ACCOUNT, JSON.stringify(data.account));
      setLocalStorageItem(EXPIRES_ON, expiresOnFromResponse);
      setExpirationTimeout(msalClient, loginRequest, expiresOnFromResponse);
    }
  }

  if (eventType === EventType.SSO_SILENT_FAILURE) {
    // There is also can be not only InteractionRequiredAuthError but another type of error
    // after which is better to switch to normal flow
    abandonSilentMode();
  }
});

window.addEventListener('storage', ({ key, newValue, oldValue }) =>{
  if (key === ACCESS_TOKEN && !newValue && oldValue) {
    // removing ACCESS_TOKEN from storage means that user logged out from another tab
    // user should be redirected to the auth page
    window.location.reload(true);
  }
});

export function checkMsalExpiration() {
  let expiresOnFromStorage = getLocalStorageItem(EXPIRES_ON);
  expiresOnFromStorage && setExpirationTimeout(msalClient, loginRequest, expiresOnFromStorage);
}

export const getRefreshTokenSecret = async () => {
  const userInformation = sessionStorage.getItem('msal.token.keys.' + process.env.REACT_APP_CLIENT_ID);
  let secret = null;
  
  if (userInformation) {
    const userInfoObject = JSON.parse(userInformation);
    const refreshToken = userInfoObject.refreshToken ? userInfoObject.refreshToken[0] : null;
    if (refreshToken) {
      const refreshTokenInformation = sessionStorage.getItem(refreshToken);
      if (refreshTokenInformation) {
        const refreshTokenObject = JSON.parse(refreshTokenInformation);
        secret = refreshTokenObject.secret;
      }
    }
  }
  
  return secret;
}
